import { createContext, FC, ReactNode, useContext } from 'react';

type WithinStoryPageContextValue = boolean;

const WithinStoryPageContext =
  createContext<WithinStoryPageContextValue>(false);

/**
 * This indicates, if the code is running inside a documented page in StoryBook.
 * (Note: This currently applies only to _pages_, not components.)
 */
export function useWithinStoryPage() {
  return useContext(WithinStoryPageContext);
}

export const WithinStoryPageProvider: FC<{
  value?: boolean;
  children: ReactNode;
}> = ({ children, value = true }) => {
  return (
    <WithinStoryPageContext.Provider value={value}>
      {children}
    </WithinStoryPageContext.Provider>
  );
};
